// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Jx7","content":"styles_content__1ZVDr"};